import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const TractionPowerGuidePage = () => <DataDrivenGuidePage slug="guide-traction-power" />;

export default TractionPowerGuidePage;
